import React, { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import trns from './trns';
import Integration from './components/Integration';
import CreationOfTestReservation from './components/CreationOfTestReservation';
import UpdateBookingStatus from './components/UpdateBookingStatus';
import ReceivingNewBookings from './components/ReceivingNewBookings';
import LoadingPharmacies from './components/LoadingPharmacies';
import AboutApi from './components/AboutApi';
import RemovalPharmacies from './components/RemovalPharmacies';
import LoadingRemainingProds from './components/LoadingRemainingProds';
import RemovalOfResidues from './components/RemovalOfResidues';
import OrderStatus from './components/OrderStatus';
import Process from './components/Process';
import ChangingDrugCart from './components/ChangingDrugCart';
import Check from './components/Check';

interface Props {
  id: string;
}
interface navigationСontent {
  id: string;
  label: string;
  content: string;
}
const navigationСontent = [
  {
    id: '/partners/integration',
    label: <FormattedMessage {...trns.Integration} />,
    content: <Integration />
  },
  {
    id: '/partners/aboutApi',
    label: <FormattedMessage {...trns.aboutApi} />,
    content: <AboutApi />
  },
  {
    id: '/partners/loadingPharmacies',
    label: <FormattedMessage {...trns.loadingPharmacies} />,
    content: <LoadingPharmacies />
  },
  {
    id: '/partners/removalPharmacies',
    label: <FormattedMessage {...trns.removalPharmacies} />,
    content: <RemovalPharmacies />
  },
  {
    id: '/partners/loadingRemainingProds',
    label: <FormattedMessage {...trns.loadingRemainingProds} />,
    content: <LoadingRemainingProds />
  },
  {
    id: '/partners/removalOfResidues',
    label: <FormattedMessage {...trns.removalOfResidues} />,
    content: <RemovalOfResidues />
  },
  {
    id: '/partners/orderStatus',
    label: <FormattedMessage {...trns.orderStatus} />,
    content: <OrderStatus />
  },
  {
    id: '/partners/process',
    label: <FormattedMessage {...trns.process} />,
    content: <Process />
  },
  {
    id: '/partners/changingDrugCart',
    label: <FormattedMessage {...trns.changingDrugList} />,
    content: <ChangingDrugCart />
  },

  {
    id: '/partners/creationOfTestReservation',
    label: <FormattedMessage {...trns.creationOfTestReservation} />,
    content: <CreationOfTestReservation />
  },
  {
    id: '/partners/receivingNewBookings',
    label: <FormattedMessage {...trns.receivingNewBookings} />,
    content: <ReceivingNewBookings />
  },

  {
    id: '/partners/updateBookingStatus',
    label: <FormattedMessage {...trns.updateBookingStatus} />,
    content: <UpdateBookingStatus />
  },
  {
    id: '/partners/check',
    label: <FormattedMessage {...trns.check} />,
    content: <Check />
  }
];

const PartnersContent: FC<Props> = ({ id }) => {
  const [item, setItem] = useState(navigationСontent[0]);

  useEffect(() => {
    const find = (array, elId) => {
      return array?.find((element) => {
        return element.id === elId;
      });
    };
    setItem(find(navigationСontent, id));
  }, [id, setItem]);

  return (
    <div>
      <div className="pb-11 w-[100%] border-b border-gallery border-solid">
        <p className="text-astronautBlue uppercase fs-header6-bold">
          {item.label}
        </p>
      </div>
      <div className="pt-8">
        <p className="text-mako fs-caption-reg">{item.content}</p>
      </div>
    </div>
  );
};

export default PartnersContent;
